import { Dayjs } from 'dayjs'
import { DatePicker } from 'govwell-ui'

import { TanstackField } from '../../../utils/forms'

type Props<TKey extends string> = {
  caption?: React.ReactNode
  field: TanstackField<Dayjs | null | undefined, TKey>
  getIsDateDisabled?: (date: Dayjs) => boolean
  isClearable?: boolean
  label?: React.ReactNode
  organizationId?: number
  placeholder?: string
  isRequired?: boolean
}
const DateField = <TKey extends string>({
  caption,
  field,
  getIsDateDisabled,
  label,
  isClearable,
  organizationId,
  placeholder,
  isRequired,
}: Props<TKey>) => {
  const errorMessage = field.state.meta.errors.join(', ')

  return (
    <DatePicker
      caption={caption}
      errorMessage={errorMessage}
      getIsDateDisabled={getIsDateDisabled}
      isClearable={isClearable}
      isInvalid={!!errorMessage}
      isRequired={isRequired}
      label={label}
      onBlur={field.handleBlur}
      onValueChange={field.setValue}
      organizationId={organizationId}
      placeholder={placeholder}
      value={field.state.value}
    />
  )
}

export default DateField
